import React, { createContext, useEffect, useState } from "react";
import beef from "./BurgerLarg.jpg";
import pizza from "./Pizzia.jpg";
import cola from "./CocaCola.jpg";
import shawerma from "./ShawermaFoode.jpg";
import strips from "./Broset.jpg";
import { toast } from "react-toastify";

export let CartProvider = createContext();

export function CartContext({ children }) {
  let [Prodacts, setProdacts] = useState([
    {
      id: 1,
      titel: "Beef burger",
      image: beef,
      Price: "150$",
      spice: "Spicy Sauce",
      span: "4 Pieces",
    },
    {
      id: 2,
      titel: "Chicken pizza",
      image: pizza,
      Price: "200$",
      spice: "No Spicy Sauce",
      span: "6 Pieces",
    },
    {
      id: 3,
      titel: "coca cola",
      image: cola,
      Price: "50$",
      spice: "Fresh",
      span: "10 Pieces",
    },
    {
      id: 4,
      titel: "Chicken shawarma",
      image: shawerma,
      Price: "170$",
      spice: "Spicy Sauce",
      span: "5 Pieces",
    },

    {
      id: 5,
      titel: "Chicken strips",
      image: strips,
      Price: "100$",
      spice: "No Spicy Sauce",
      span: "11 Pieces",
    },
  ]);
  let [cartitem, setcartitem] = useState(() => {
    let saved = localStorage.getItem("cartitem");
    return saved ? JSON.parse(saved) : [];
  });
  let addcart = (item) => {
    setcartitem((prevItems) => [...prevItems, item]);
    toast("تم الاضافه بنجاح");
  };
  let remove = (id) => {
    setcartitem((prevItems) => prevItems.filter((item) => item.id !== id));
    toast("تم ازاله المنتج");
  };

  useEffect(() => {
    localStorage.setItem("cartitem", JSON.stringify(cartitem));
  }, [cartitem]);

  return (
    <CartProvider.Provider value={{ addcart, Prodacts, cartitem, remove }}>
      {children}
    </CartProvider.Provider>
  );
}

export default CartContext;
